import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread2";
import { createNotificationProxy } from '.';
import { extractMessageParams, randomString } from '../helpers';
var defaultOptions = {
  intent: 'info',
  title: '',
  message: '',
  timeout: 5000,
  dismissible: true
};
export var notifyInfo = function notifyInfo(message) {
  var options = _objectSpread(_objectSpread(_objectSpread({}, defaultOptions), {}, {
    id: randomString()
  }, extractMessageParams(message)), {}, {
    intent: 'info'
  });
  return createNotificationProxy(options);
};

// alias
export var notify = notifyInfo;
export var notifySuccess = function notifySuccess(message) {
  var options = _objectSpread(_objectSpread(_objectSpread({}, defaultOptions), {}, {
    id: randomString()
  }, extractMessageParams(message)), {}, {
    intent: 'success'
  });
  return createNotificationProxy(options);
};
export var notifyProgress = function notifyProgress(message) {
  var options = _objectSpread(_objectSpread(_objectSpread({}, defaultOptions), {}, {
    id: randomString()
  }, extractMessageParams(message)), {}, {
    intent: 'progress'
  });
  return createNotificationProxy(options);
};
export var notifyWarning = function notifyWarning(message) {
  var options = _objectSpread(_objectSpread(_objectSpread({}, defaultOptions), {}, {
    id: randomString(),
    timeout: 8000
  }, extractMessageParams(message)), {}, {
    intent: 'warning'
  });
  return createNotificationProxy(options);
};
export var notifyDanger = function notifyDanger(message) {
  var options = _objectSpread(_objectSpread(_objectSpread({}, defaultOptions), {}, {
    id: randomString(),
    timeout: 8000
  }, extractMessageParams(message)), {}, {
    intent: 'danger'
  });
  return createNotificationProxy(options);
};